import { ApprovalDialog } from '@components/Forms';
import { useToast } from 'hooks';
import React from 'react';
import { IAccessKeyRowAction } from './types';

const AccessKeyDeleteDialog: React.FC<IAccessKeyRowAction<string, string>> = ({
	onComplete,
	row,
	mutation,
	accessKeyType
}) => {
	const { invokeToastableAction } = useToast();
	const handleDelete = async () =>
		invokeToastableAction(
			() => mutation.mutateAsync(row?.row.id),
			`${accessKeyType}.action.delete.dialog.toast`,
			onComplete
		);

	return (
		<ApprovalDialog
			onApprove={handleDelete}
			onCancel={onComplete}
			title={intl.tr(`${accessKeyType}.action.delete.dialog.header`)}
			question={intl.tr(`${accessKeyType}.action.delete.dialog.question`, {
				name: row?.row.name || ''
			})}
			approveText={intl.tr('button.delete')}
			cancelText={intl.tr('button.cancel')}
		/>
	);
};

export default AccessKeyDeleteDialog;
